import { request } from './api';

/**
 * Action constants
 */
export const REALLOCATE_SAVE = 'REALLOCATE_SAVE';
export const REALLOCATE_DELETE = 'REALLOCATE_DELETE';
export const REALLOCATE_UPDATE_PARAMETER = 'REALLOCATE_UPDATE_PARAMETER';
export const REALLOCATE_REQUEST = 'REALLOCATE_REQUEST';
export const REALLOCATE_RESET = 'REALLOCATE_RESET';
export const REALLOCATE_ADD_ITEM = 'REALLOCATE_ADD_ITEM';
export const REALLOCATE_REMOVE_ITEM = 'REALLOCATE_REMOVE_ITEM';

/**
 * Action creators
 */

export function calcRebalance() {
  return async (dispatch, getState) => {
    dispatch({ type: REALLOCATE_REQUEST });
    const state = getState();

    const { tradeRecommendations } = state.Accounts;
    const fundallocator = state.FundAllocator;

    const {
      targetTypePorts,
      selectedAccount,
      selectedTargetAcc,
      selectedTargetPort,
      cashAmount,
      cashAdd,
    } = state.ReallocateAccount;

    const formatted = [];
    const exchange = localStorage.getItem('pwpa-exchange-rate') || 1;

    function getCombinedHolding(accountsArr, ticker) {
      const result = { current_qty: 0, name: '', currency: 'CAD', price: 0 };

      for (let i = 0; i < accountsArr.length; i += 1) {
        const acc = accountsArr[i];
        if (acc && acc.holdings) {
          const index = acc.holdings.findIndex(
            (x) =>
              x.gic_ticker === ticker ||
              x.security === ticker ||
              x.ticker === ticker
          );

          if (index >= 0) {
            const h = acc.holdings[index];
            result.current_qty += h.quantity || 0;
            result.currency = h.currency || result.currency;
            if (h.unadjusted_closing_price && h.unadjusted_closing_price.CAD) {
              result.price = h.unadjusted_closing_price.CAD;
            } else if (
              h.security_detail &&
              h.security_detail.unadjusted_closing_price &&
              h.security_detail.unadjusted_closing_price.CAD
            ) {
              result.price = h.security_detail.unadjusted_closing_price.CAD;
            }
            if (
              h.security_detail &&
              h.security_detail.long_name &&
              result.name === ''
            ) {
              result.name = h.security_detail.long_name;
            }
          }
        }
      }

      return result;
    }

    if (targetTypePorts) {
      if (
        !fundallocator ||
        !fundallocator.output ||
        fundallocator.output._notes.new_fund_allocation_failed
      )
        return [];

      const missingTickers = [];
      const refAcc =
        selectedAccount && selectedAccount.length
          ? selectedAccount[0]
          : { holdings: [] };

      Object.keys(fundallocator.output).forEach((key) => {
        if (key === '_notes') return;
        const ticker = key;

        const index = refAcc.holdings
          ? refAcc.holdings.findIndex(
              (x) =>
                x.gic_ticker === ticker ||
                x.security === ticker ||
                x.ticker === ticker
            )
          : -1;

        if (index < 0) missingTickers.push(ticker);
      });

      const missingResults = {};
      if (missingTickers.length > 0) {
        const tickers_string = missingTickers.join(',');
        const result = await dispatch(
          request('get', '/security/', {
            query: `?symbols=${tickers_string}`,
          })
        );

        for (let i = 0; i < result.length; i += 1) {
          const holding = result[i];
          missingResults[holding.ticker] = holding.long_name;
        }
      }

      Object.keys(fundallocator.output).forEach((ticker) => {
        if (ticker === '_notes') return;

        const item = fundallocator.output[ticker];
        const action_amount = item.rebalancing_buy;
        let price = item.security_price;
        if (item.security_currency === 'USD') price *= exchange;

        const currency = item.security_currency || 'CAD';
        let finalTicker = ticker;
        let name = '';

        const refHold = getCombinedHolding(selectedAccount, ticker);
        const { current_qty } = refHold;
        if (refHold.name !== '') {
          ({ name } = refHold);
        }
        if (/^GIC\d+:MKT$/.test(ticker)) {
          if (refAcc.holdings && refAcc.holdings.length && currency === 'CAD') {
            const index = refAcc.holdings.findIndex(
              (x) => x.gic_ticker === ticker
            );
            if (index >= 0) {
              finalTicker = refAcc.holdings[index].gic_ticker;
              name = refAcc.holdings[index].gic_name || name;
            }
          } else if (
            selectedTargetPort &&
            selectedTargetPort.length &&
            selectedTargetPort[0].gic_info &&
            selectedTargetPort[0].gic_info[ticker]
          ) {
            const tg = selectedTargetPort[0].gic_info[ticker];
            finalTicker = tg.gic_ticker || ticker;
            name = tg.gic_name || name;
          }
        }

        if (name === '') name = missingResults[ticker] || '';

        const target_qty = current_qty + action_amount;

        formatted.push({
          ticker: finalTicker,
          name,
          action_amount,
          currency,
          price,
          current_qty,
          target_qty,
        });
      });

      formatted.push(fundallocator.output._notes.extra_cash_cad_after);
    } else {
      if (!tradeRecommendations || !tradeRecommendations.holdingsDiff)
        return [];

      tradeRecommendations.holdingsDiff.forEach((item) => {
        const { ticker } = item;
        const { name } = item;
        const action_amount = item.quantity;

        const fromHold = getCombinedHolding(selectedAccount, ticker);
        const toHold = getCombinedHolding(selectedTargetAcc, ticker);

        formatted.push({
          ticker,
          name,
          action_amount,
          currency: fromHold.currency,
          price: fromHold.price || toHold.price,
          current_qty: fromHold.current_qty,
          target_qty: toHold.current_qty,
        });
      });
      const exchangeRate =
        selectedAccount &&
        selectedAccount.length &&
        selectedAccount[0].currency === 'USD'
          ? Number(localStorage.getItem('pwpa-exchange-rate'))
          : 1;

      const mult = cashAdd ? -1 * exchangeRate : 1 * exchangeRate;
      formatted.push(mult * Number(cashAmount));
    }

    dispatch(addReallocate(formatted));

    return formatted;
  };
}

export function updateParameter(field, value) {
  return {
    type: REALLOCATE_UPDATE_PARAMETER,
    field,
    value,
  };
}

export function addItem(field, value) {
  return {
    type: REALLOCATE_ADD_ITEM,
    field,
    value,
  };
}

export function removeItem(field, value) {
  return {
    type: REALLOCATE_REMOVE_ITEM,
    field,
    value,
  };
}

export function addReallocate(data) {
  return {
    type: REALLOCATE_SAVE,
    data,
  };
}
export function deleteReallocate(data) {
  return {
    type: REALLOCATE_DELETE,
    data,
  };
}

export function resetReallocate() {
  return {
    type: REALLOCATE_RESET,
  };
}
